import React from 'react';
import QRCode from 'qrcode.react';
import GalleryComponent from './GalleryComponent';
import PromoComponent from './PromoComponent';

var headerLogo = require('../images/headerLogo.png');

class ArticleComponent extends React.Component {
  constructor(props) {
    super(props);
    this.hideEcommerceTimeout;
    this.state = {
      showEcommerce: false,
      showPromo: this.props.article.hasPromo
    };
  }

  _handleBuyButtonClick() {
    this.hideEcommerceTimeout = setTimeout(() => {
      this._restoreEcommerce();
    }, 2000);
    this.setState({
      showEcommerce: true
    });
    this.props.buyClicked();
  }

  _restoreEcommerce() {
    this.setState({
      showEcommerce: false
    });
  }

  _restoreTimeout() {
    clearTimeout(this.hideEcommerceTimeout);
    this.hideEcommerceTimeout = setTimeout(() => {
      this._restoreEcommerce();
    }, 2000);
  }

  _handleAttendantButtonClick() {
    this.props.attendantClicked(this.props.article.brandId, this.props.article.id);
  }

  _handleFrameClicked() {
    this.props.ecommerceClicked();
  }

  _handleBackButtonClick() {
    this.props.backButtonClicked();
  }

  _onCancelModal(id) {
    this.setState({
      showPromo: 0
    });
    this.props.restoreInterval();
  }

  render() {
    let article = this.props.article;
    let ecommerce = this.state.showEcommerce ?
      <div className="ecommerce-wrapper">
        <iframe src={this.props.article.linkUrl} width="100%" height="100%" />
      </div>
      :
      ''
      ;
    /*      
      <div className="article-page-footer">
        <button className="btn" onClick={this._handleBackButtonClick.bind(this)}>Volver</button>
      </div>
     */
    let articleBody =
      <div className="article-body">
        <div className="article-content">
          <div className="article-gallery">
            <GalleryComponent images={article.images} />
          </div>
          <div className="article-details">
            {}
            <div className="article-title">
              <span>{article.name}</span>
            </div>
            <div className="article-description">
              <p dangerouslySetInnerHTML={{ __html: article.description }}></p>
            </div>
          </div>
          <div className="article-details-box">
            <div className="article-price">
              <label>Precio en un pago</label>
              <span><small>{article.currency}</small>{article.price}</span>
            </div>
            <div className="hide-on-mobile">
              <QRCode size={128} level={'Q'} value={article.linkUrl} />
            </div>
            <div className="actions-buttons">
              <button className="btn" onClick={this._handleBuyButtonClick.bind(this)} >COMPRAR <label><i className="fa fa-shopping-cart" aria-hidden="true"></i></label></button>
              <button className="btn" onClick={this._handleAttendantButtonClick.bind(this)} >VENDEDOR<label><i className="fa fa-user-circle" aria-hidden="true"></i></label></button>
            </div>
          </div>
        </div>
      </div>;

    let body = this.state.showPromo > 0 ? <PromoComponent article={this.props.article} cancelModal={this._onCancelModal.bind(this, '#promoModal')} /> : articleBody;
    return (
      <div className="article-component">
        {ecommerce}
        <div className={this.state.showPromo > 0 ? "hide-element" : "article-page-header"}>
          <img className="header-logo" src={headerLogo} />
          <div className="header-back-button">
            <button className="btn" onClick={this._handleBackButtonClick.bind(this)}><label><i className="fa fa-chevron-left" aria-hidden="true"></i></label>Volver</button>
          </div>
        </div>
        {body}
      </div>
    );
  }
}

export default ArticleComponent;



// WEBPACK FOOTER //
// ./src/components/ArticleComponent.js